export { default } from './use-get-last-couple-records'
